import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useMaterialsLookup, useUnitLookup } from '../graphql/queries';
import { useSave } from '../graphql/hooks';
import Loading from '../teal-react/components/molecules/Loading';
import { IconButton } from '@mui/material';
import { Checklist, Edit } from '@mui/icons-material';

interface FormulaMaterialFormProps {
  model: any;
  onClose?: () => void;
}

const BatchMaterialForm = ({ model, onClose }: FormulaMaterialFormProps) => {
  const [usetext, setUsetext] = React.useState(Boolean(model.material));
  const { data: units } = useUnitLookup();
  const { data: materials } = useMaterialsLookup();
  const save = useSave('batch_material', ['batch', 'qc']);

  if (!units || !materials) {
    return <Loading />;
  }
  return (
    <SimpleForm
      style={
        {
          // minHeight: '500px',
        }
      }
      header={model.id ? 'Edit Material' : 'Add Material'}
      cancel={onClose}
      model={model}
      save={({ modified, merged }: { modified: any; merged: any }) => {
        if (Boolean(model.id)) {
          save({
            id: model.id,
            ...modified,
          });
        } else {
          save(merged, true);
        }

        onClose?.();
      }}
      fields={[
        {
          label: 'Material',
          name: 'material',
          size: 11,
          options: usetext
            ? undefined
            : materials.material.map((u: any) => ({
                label: u.name,
                // value: u.id,
                id: u.name,
              })),
          // disabled: Boolean(model.id),
          validate: { required: true },
          filterable: !usetext, // use searchable select
        },
        {
          size: 1,
          content: (
            <IconButton
              onClick={() => setUsetext(!usetext)}
              title="Toggle Select/Type"
            >
              {usetext ? <Checklist /> : <Edit />}
            </IconButton>
          ),
        },
        {
          name: 'amount',
          label: 'Amount',
          size: 3,
          validate: { required: true },
          number: true,
        },
        {
          name: 'unit_id',
          label: 'Unit',
          size: 3,
          options: units.unit.map((u: any) => ({
            label: u.name,
            value: u.id,
          })),
          validate: { required: true },
        },
        {
          name: 'remark',
          label: 'Remark',
          size: 6,
        },
      ]}
    />
  );
};

export default BatchMaterialForm;
